import react from "react";
import Header from "../general/Header";

import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf'
import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import Unauthorized from "../general/Unauthorized";
import { Modal, Button } from "react-bootstrap";
import { validarArchivoEsImagen } from "../../../resources/Helper";
import { resizeImage } from "../../../utils/imageHelpers";
import { escolaridades } from "../../../resources/Helper";
import SelectorCiudad from "../custom/SelectorCiudad";
import { baseUrl } from "../../../resources/Constants";
import SelectorPais from "../custom/SelectorPais";
import SelectorTipoDocumento from "../custom/SelectorTipoDocumento";
import SelectorSexo from "../custom/SelectorSexo";
import SelectorIdentidadGenero from "../custom/SelectorIdentidadGenero";
import SelectorTipoSangre from "../custom/SelectorTipoSangre";
import SelectorEstadoCivil from "../custom/SelectorEstadoCivil";
import SelectorDiscapacidad from "../custom/SelectorDiscapacidad";
import SelectorEscolaridad from "../custom/SelectorEscolaridad";
import SelectorEtnia from "../custom/SelectorEtnia";
import SelectorClasificacionPaciente from "../custom/SelectorClasificacionPaciente";
import SelectorZona from "../custom/SelectorZona";
import SelectorVinculacion from "../custom/SelectorVinculacion";
import SelectorEPS from "../custom/SelectorEPS";
import SelectorClasificacionRiesgo from "../custom/SelectorClasificacionRiesgo";
import SelectorConvenio from "../custom/SelectorConvenio";
import SelectorMedioPublicitario from "../custom/SelectorMedioPublicitario";
import SelectorProfesionalAsignado from "../custom/SelectorProfesionalAsignado";

const ZONA_COLOMBIA = 'America/Bogota';

/** Fecha/hora actual en Colombia para input datetime-local (YYYY-MM-DDTHH:mm). */
const fechaHoraColombiaActual = () => {
    const partes = new Intl.DateTimeFormat('en-CA', {
        timeZone: ZONA_COLOMBIA,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    }).formatToParts(new Date());
    const v = (tipo) => partes.find((p) => p.type === tipo)?.value ?? '00';
    return `${v('year')}-${v('month')}-${v('day')}T${v('hour')}:${v('minute')}`;
};

const formatearFechaIngresoParaInput = (valor) => {
    if (!valor) return "";
    const texto = String(valor).trim();
    if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}/.test(texto)) {
        return texto.replace(' ', 'T').slice(0, 16);
    }
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(texto)) return texto.slice(0, 16);
    return texto.slice(0, 16);
};

function CrearPaciente2() {

    const [primerNombre, setPrimerNombre] = useState('');
    const [segundoNombre, setSegundoNombre] = useState('');
    const [primerApellido, setPrimerApellido] = useState('');
    const [segundoApellido, setSegundoApellido] = useState('');
    const [fechaIngreso, setFechaIngreso] = useState(fechaHoraColombiaActual);
    const [numeroDocumento, setNumeroDocumento] = useState('');
    const [tipoDocumento, setTipoDocumento] = useState('');
    const [genero, setGenero] = useState('');
    const [tipoSangre, setTipoSangre] = useState('');
    const [estadoCivil, setEstadoCivil] = useState('');
    const [fechaNacimiento, setFechaNacimiento] = useState('');
    const [paisNacimiento, setPaisNacimiento] = useState('');
    const [ciudadNacimiento, setCiudadNacimiento] = useState('');
    const [nombreCiudadExterior, setNombreCiudadExterior] = useState('');
    const [ocupacion, setOcupacion] = useState('');
    const [codigoOcupacion, setCodigoOcupacion] = useState('');
    const [nombreOcupacion, setNombreOcupacion] = useState('');
    const [religion, setReligion] = useState('');
    const [nacionalidad, setNacionalidad] = useState('');
    const [estadoPaciente, setEstadoPaciente] = useState('');


    const [ciudadResidencia, setCiudadResidencia] = useState(null);


    const [raza, setRaza] = useState('');
    const [escolaridad, setEscolaridad] = useState('');
    const [direccion, setDireccion] = useState('');
    const [pais, setPais] = useState('');
    const [ciudad, setCiudad] = useState('');
    const [zona, setZona] = useState('');
    const [telefono, setTelefono] = useState('');
    const [celular, setCelular] = useState('');
    const [email, setEmail] = useState('');
    const [paisResidencia, setPaisResidencia] = useState('');
    const [vinculacion, setVinculacion] = useState('');
    const [eps, setEps] = useState('');
    const [clasificacion, setClasificacion] = useState('');
    const [convenio, setConvenio] = useState('');
    const [medioPublicitario, setMedioPublicitario] = useState('');
    const [referido, setReferido] = useState('');
    const [nombreAcompanante, setNombreAcompanante] = useState('');
    const [telefonoAcompanante, setTelefonoAcompanante] = useState('');
    const [parentescoAcompanante, setParentescoAcompanante] = useState('');
    const [docAcompanante, setDocAcompanante] = useState('');
    const [emailAcompanante, setEmailAcompanante] = useState('');
    const [nombreResponsable, setNombreResponsable] = useState('');
    const [telefonoResponsable, setTelefonoResponsable] = useState('');
    const [docResponsable, setDocResponsable] = useState('');
    const [emailResponsable, setEmailResponsable] = useState('');
    const [parentescoResponsable, setParentescoResponsable] = useState('');
    const [nombreMadre, setNombreMadre] = useState('');
    const [documentoMadre, setDocumentoMadre] = useState('');
    const [telefonoMadre, setTelefonoMadre] = useState('');
    const [ocupacionMadre, setOcupacionMadre] = useState('');
    const [nombrePadre, setNombrePadre] = useState('');
    const [documentoPadre, setDocumentoPadre] = useState('');
    const [telefonoPadre, setTelefonoPadre] = useState('');
    const [ocupacionPadre, setOcupacionPadre] = useState('');
    const [clasificacionRiesgo, setClasificacionRiesgo] = useState('');
    const [descripcionClasificacion, setDescripcionClasificacion] = useState('');

    // Estados para controlar acordeones
    const [acordeonDatosPersonales, setAcordeonDatosPersonales] = useState(true);
    const [acordeonDomicilio, setAcordeonDomicilio] = useState(false);
    const [acordeonDatosAdicionales, setAcordeonDatosAdicionales] = useState(false);
    const [acordeonAcompanante, setAcordeonAcompanante] = useState(false);
    const [acordeonResponsable, setAcordeonResponsable] = useState(false);
    const [acordeonMenores, setAcordeonMenores] = useState(false);

    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(true);
    const [hasPermission, setHasPermission] = useState(false);
    const [client, setClient] = useState([]);
    const [aseguradoras, setAseguradoras] = useState([]);
    const [convenios, setConvenios] = useState([]);
    const [mediosPublicitarios, setMediosPublicitarios] = useState([]);

    const [idPaisNacimiento, setIdPaisNacimiento] = useState();
    const [idCiudadNacimiento, setIdCiudadNacimiento] = useState();
    const [idCiudad, setIdCiudad] = useState();
    const [idNacionalidad, setIdNacionalidad] = useState();
    const [idPaisResidencia, setIdPaisResidencia] = useState();

    const [etnia, setEtnia] = useState();
    const [identidadGenero, setIdentidadGenero] = useState();
    const [profesionalAsignado, setProfesionalAsignado] = useState('');


    const [discapacidad, setDiscapacidad] = useState('08');
    const [causaAtencion, setCausaAtencion] = useState();
    const [tecnologiaSalud, setTecnologiaSalud] = useState();
    const [finalidadTecnologiaSalud, setFinalidadTecnologiaSalud] = useState();


    const [errorlist, setErrorlist] = useState({});
    const errorSummaryRef = useRef(null);

    const [perfilimg, setPerfilimg] = useState('/dist/img/user-default.jpg');
    const [imgperfildata, setImgperfildata] = useState('');
    const [btnstate, setBtnstate] = useState(true);
    const [btnclass, setBtnclass] = useState('btn btn-primary btn-disabled');

    // variables para consulta de ocupacion
    const [resultadosOcupacion, setResultadosOcupacion] = useState([]);
    const [resultadosOcupacionState, setResultadosOcupacionState] = useState('');
    const [deshabilitarInputOcupacion, setDeshabilitarInputOcupacion] = useState(false);
    const [btnEliminarOcupacionVisible, setBtnEliminarOcupacionVisible] = useState('hide');

    const [verDescripcionClasificacion, setVerDescripcionClasificacion] = useState('hide');

    let history = useHistory();
    let userdata = [];


    const [mensajeModal, setMensajeModal] = useState('');
    const [showModal, setShowModal] = useState(false);
    const handleShowModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);
    const handleAtenderPaciente = () => history.push('/atender-paciente');


    useEffect(() => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🔒 VALIDACIÓN DE PERMISOS - Verificar acceso a crear pacientes
        const tienePermiso = userdata.up && userdata.up.includes('crearPacientes');

        if (!tienePermiso) {
            setHasPermission(false);
            return; // Detener ejecución si no tiene permisos
        }

        setHasPermission(true);

        // Cargar aseguradoras y medios publicitarios con axios
        axios.get('/aseguradoras')
            .then(response => {
                if (response.status === 200) {
                    setAseguradoras(response.data);
                }
            })
            .catch(error => {
                console.error('Error cargando aseguradoras:', error);
            });

        axios.get('/medios-publicitarios')
            .then(response => {
                if (response.status === 200) {
                    setMediosPublicitarios(response.data);
                }
            })
            .catch(error => {
                console.error('Error cargando medios publicitarios:', error);
            });
    }, []);



    const handleSubmit = (e) => {
        e.preventDefault();

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }




        const data = {
            client_id: userdata.client_id,
            primer_nombre: primerNombre,
            segundo_nombre: segundoNombre,
            primer_apellido: primerApellido,
            segundo_apellido: segundoApellido,
            numero_documento: numeroDocumento,
            tipo_documento: tipoDocumento,
            email: email,
            celular: celular,
            sexo: genero,
            rh: tipoSangre,
            estado_civil: estadoCivil,
            fecha_nacimiento: fechaNacimiento,
            ciudad_nacimiento: ciudadNacimiento,

            nombre_ciudad_exterior: nombreCiudadExterior,
            ocupacion: codigoOcupacion,
            nombre_ocupacion: nombreOcupacion,
            religion: religion,
            etnia: etnia,
            identidad_genero: identidadGenero,

            raza: raza,
            escolaridad: escolaridad,
            nacionalidad: idNacionalidad,
            direccion: direccion,
            ciudad: ciudadResidencia,
            zona: zona,
            telefono: telefono,
            vinculacion: vinculacion,
            eps: eps,
            clasificacion_riesgo: clasificacionRiesgo,
            descripcion_clasificacion: descripcionClasificacion,
            convenio: convenio,
            medio_publicitario: medioPublicitario,
            referido_por: referido,
            nombre_acompanante: nombreAcompanante,
            telefono_acompanante: telefonoAcompanante,
            doc_acompanante: docAcompanante,
            email_acompanante: emailAcompanante,
            parentesco_acompanante: parentescoAcompanante,
            nombre_responsable: nombreResponsable,
            telefono_responsable: telefonoResponsable,
            doc_responsable: docResponsable,
            email_responsable: emailResponsable,
            parentesco_responsable: parentescoResponsable,
            nombre_madre: nombreMadre,
            documento_madre: documentoMadre,
            telefono_madre: telefonoMadre,
            ocupacion_madre: ocupacionMadre,
            nombre_padre: nombrePadre,
            documento_padre: documentoPadre,
            telefono_padre: telefonoPadre,
            ocupacion_padre: ocupacionPadre,
            estado: '1',
            fechaingreso: fechaIngreso,
            pais_nacimiento: paisNacimiento,
            pais_residencia: paisResidencia,

            discapacidad: discapacidad,
            causa_atencion: '38',
            tecnologia_salud: '01',
            finalidad_tecnologia_salud: '12',
            id_users: profesionalAsignado || null,
            tipo_cliente: 0, // 0 = Paciente

        };

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        };


        ///////////////////////////

        axios.post('/paciente', data, config)
            .then(response => {
                setLoading(false);

                const pacienteId = response.data.resultado;

                if (imgperfildata) {
                    const formData = new FormData();

                    formData.append('image', imgperfildata);
                    formData.append('id', pacienteId);

                    axios.post('/fotoperfil-paciente', formData)
                        .then((res) => {
                            if (res.status === 200) {
                                setPerfilimg(res.data.url);
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                        })
                }

                localStorage.setItem('showtoast', true);
                history.push('/pacientes');
            })
            .catch(error => {
                setErrorlist(error.response.data.errors);
            })
    }



    const agregarFotoPerfil = async (file) => {
        const selectedFile = file[0];
        
        if (!selectedFile) return;
        
        setErrorlist({});
        
        // Validar tipo de archivo
        if (!validarArchivoEsImagen(selectedFile)) {
            setErrorlist({ imagen_perfil: 'Tipo de archivo no válido' });
            setPerfilimg('/dist/img/user-default.jpg');
            return;
        }
        
        try {
            // Redimensionar imagen antes de guardarla
            const resizedBlob = await resizeImage(selectedFile, 800, 800, 0.8);
            
            // Crear File desde Blob para mantener compatibilidad
            const resizedFile = new File([resizedBlob], selectedFile.name, {
                type: selectedFile.type,
                lastModified: Date.now()
            });
            
            setImgperfildata(resizedFile);
            const f = URL.createObjectURL(resizedFile);
            setPerfilimg(f);
            setBtnstate(false);
            setBtnclass('btn btn-primary');
        } catch (error) {
            console.error('Error al procesar imagen:', error);
            setErrorlist({ imagen_perfil: 'Error al procesar la imagen' });
            setPerfilimg('/dist/img/user-default.jpg');
        }
    }


    useEffect(() => {

        if (imgperfildata) {
            if (!validarArchivoEsImagen(imgperfildata)) {
                setErrorlist({ imagen_perfil: 'Tipo de archivo no válido' });
                setPerfilimg('/dist/img/user-default.jpg');
            }
            // Ya no es necesario validar tamaño porque la imagen se redimensiona
        }
    }, [imgperfildata]);


    useEffect(() => {
        if (clasificacionRiesgo == 'medio' || clasificacionRiesgo == 'alto') {
            setVerDescripcionClasificacion('');
        }
        else {
            setVerDescripcionClasificacion('hide');
        }
    }, [clasificacionRiesgo]);


    useEffect(() => {
        if (Object.keys(errorlist).length > 0) {
            const timer = setTimeout(() => {
                setErrorlist({});
            }, 12000); // 12 segundos para permitir lectura

            return () => clearTimeout(timer);
        }
    }, [errorlist]);

    useEffect(() => {
        if (Object.keys(errorlist).length > 0 && errorSummaryRef.current) {
            errorSummaryRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
            errorSummaryRef.current.focus({ preventScroll: true });
        }
    }, [errorlist]);






    // 🔒 PROTECCIÓN DE RUTA - Si no tiene permisos, mostrar página de acceso denegado
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    return (



        <div className="hold-transition">
            <Header />
            <Aside activelink="patients" />

            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-8">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                    <li className="breadcrumb-item" key="bc2"><Link to="/menu-pacientes">Pacientes</Link></li>
                                    <li className="breadcrumb-item" key="bc3"><Link to="/pacientes">Listado de Pacientes</Link></li>
                                    <li className="breadcrumb-item" key="bc4">Crear Paciente</li>
                                </ol>

                                {Object.keys(errorlist).length > 0 && (
                                    <div
                                        ref={errorSummaryRef}
                                        tabIndex="-1"
                                        className="alert alert-danger alert-dismissible fade show"
                                        role="alert"
                                    >
                                        <button type="button" className="close" aria-label="Cerrar" onClick={() => setErrorlist({})}>
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                        <ul className="mb-0">
                                            {Object.values(errorlist).map((messages, index) => (
                                                <li key={index}>{messages[0]}</li>
                                            ))}
                                        </ul>
                                    </div>
                                )}

                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-sm-8">
                                <h1 className="m-0">Crear Paciente</h1>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="content" >
                    <div className="container-fluid">

                        <form id="role-form" onSubmit={handleSubmit} autoComplete="off">
                            <p className="text-muted small mb-3">
                                Los campos marcados con <span className="text-danger">*</span> son obligatorios.
                            </p>
                            <div className="row">
                                <div className="col-md-12">

                                    <div className="card">
                                        <div className="card-header">
                                            <h4 className="card-title w-100">
                                                <button
                                                    type="button"
                                                    className="btn btn-link d-block w-100 text-left p-0"
                                                    onClick={() => setAcordeonDatosPersonales(!acordeonDatosPersonales)}
                                                    aria-expanded={acordeonDatosPersonales}
                                                    style={{ textDecoration: 'none', color: 'inherit', fontWeight: 'bold'}}
                                                >
                                                    <i className="fas fa-id-card-alt mr-2 text-info"></i>
                                                    Datos Personales
                                                </button>
                                            </h4>
                                        </div>
                                        <div className={`collapse ${acordeonDatosPersonales ? 'show' : ''}`}>
                                            <div className="paciente-img" style={{ padding: '20px', marginTop: '36px' }}>
                                                <div className="paciente-profile-img-container">
                                                    <img
                                                        src={perfilimg || "/default-profile.png"}
                                                        alt="Foto de perfil"
                                                        className="profile-img"
                                                    />
                                                    <input
                                                        type="file"
                                                        name="perfilimg"
                                                        id="perfilimg"
                                                        className="form-control profile-img-control"
                                                        accept=".jpg, .png, .jpeg"
                                                        onChange={(e) => agregarFotoPerfil(e.target.files)}
                                                    />
                                                </div>
                                                <label htmlFor="perfilimg" className="lbl-cargar-foto-perfil">Cargar Imagen</label>

                                                {errorlist?.imagen_perfil && (
                                                    <div className="invalid-feedback visible">
                                                        {errorlist.imagen_perfil}
                                                    </div>
                                                )}
                                            </div>
                                            <div className="card-body paciente-meta" style={{ paddingLeft: '5px' }}>

                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="fechaIngreso">Fecha de ingreso</label>
                                                            <input
                                                                type="datetime-local"
                                                                name="fecha-ingreso"
                                                                className="form-control"
                                                                id="fechaIngreso"
                                                                value={fechaIngreso}
                                                                onChange={(e) => setFechaIngreso(e.target.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="companyName">Primer Nombre <span className="text-danger">*</span></label>
                                                            <input type="text" name="company-name" className={`form-control ${errorlist.primer_nombre ? 'is-invalid' : ''}`} id="companyName" value={primerNombre} onChange={(e) => setPrimerNombre(e.target.value)} />
                                                            <div className="invalid-feedback visible">
                                                                {errorlist.primer_nombre?.[0]}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="companyName">Segundo Nombre</label>
                                                            <input type="text" name="company-name" className="form-control" id="companyName" value={segundoNombre} onChange={(e) => setSegundoNombre(e.target.value)} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="companyName">Primer Apellido</label>
                                                            <input type="text" name="company-name" className="form-control" id="companyName" value={primerApellido} onChange={(e) => setPrimerApellido(e.target.value)} />
                                                            <div className="invalid-feedback visible">
                                                                {/*    {errorlist.primer_apellido}  */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>


                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="companyName">Segundo Apellido</label>
                                                            <input type="text" name="company-name" className="form-control" id="companyName" value={segundoApellido} onChange={(e) => setSegundoApellido(e.target.value)} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <SelectorTipoDocumento
                                                            value={tipoDocumento}
                                                            onChange={setTipoDocumento}
                                                            error={errorlist.tipo_documento?.[0]}
                                                            required={true}
                                                        />
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="companyName">Número de Documento <span className="text-danger">*</span></label>
                                                            <input type="text" name="company-name" className={`form-control ${errorlist.numero_documento ? 'is-invalid' : ''}`} id="companyName" value={numeroDocumento} onChange={(e) => setNumeroDocumento(e.target.value)} />
                                                            <div className="invalid-feedback visible">
                                                                {errorlist.numero_documento?.[0]}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <SelectorSexo
                                                            value={genero}
                                                            onChange={setGenero}
                                                            error={errorlist.sexo?.[0]}
                                                            required={true}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <SelectorIdentidadGenero
                                                            value={identidadGenero}
                                                            onChange={setIdentidadGenero}
                                                            error={errorlist.identidad_genero?.[0]}
                                                        />
                                                    </div>

                                                    <div className="col-md-3">
                                                        <SelectorTipoSangre
                                                            value={tipoSangre}
                                                            onChange={setTipoSangre}
                                                            error={errorlist.rh?.[0]}
                                                        />
                                                    </div>

                                                    <div className="col-md-3">
                                                        <SelectorEstadoCivil
                                                            value={estadoCivil}
                                                            onChange={setEstadoCivil}
                                                            error={errorlist.estado_civil?.[0]}
                                                        />
                                                    </div>

                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="religion">Religión</label>
                                                            <input
                                                                type="text"
                                                                name="religion"
                                                                className="form-control"
                                                                id="religion"
                                                                value={religion}
                                                                onChange={(e) => setReligion(e.target.value)}
                                                            />
                                                        </div>
                                                    </div>

                                                </div>

                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="fechaNacimiento">Fecha de Nacimiento <span className="text-danger">*</span></label>
                                                            <input type="date" name="fecha-nacimiento" className={`form-control ${errorlist.fecha_nacimiento ? 'is-invalid' : ''}`} id="fechaNacimiento" value={fechaNacimiento} onChange={(e) => setFechaNacimiento(e.target.value)} />
                                                            <div className="invalid-feedback visible">
                                                                {errorlist.fecha_nacimiento?.[0]}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="paisNacimiento">País de Nacimiento <span className="text-danger">*</span></label>
                                                            <SelectorPais
                                                                value={paisNacimiento}
                                                                onChange={setPaisNacimiento}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="ciudadNacimiento">Ciudad de Nacimiento</label>
                                                            <SelectorCiudad
                                                                value={ciudadNacimiento}
                                                                onChange={setCiudadNacimiento}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="nombreOcupacion">Ocupación</label>
                                                            <input
                                                                type="text"
                                                                name="nombreOcupacion"
                                                                className="form-control"
                                                                id="nombreOcupacion"
                                                                value={nombreOcupacion}
                                                                onChange={(e) => setNombreOcupacion(e.target.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-9">
                                                        <SelectorProfesionalAsignado
                                                            value={profesionalAsignado}
                                                            onChange={setProfesionalAsignado}
                                                            error={errorlist.id_users?.[0]}
                                                        />
                                                    </div>
                                                </div>



                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <SelectorDiscapacidad
                                                            value={discapacidad}
                                                            onChange={setDiscapacidad}
                                                            error={errorlist.discapacidad?.[0]}
                                                        />
                                                    </div>
                                                    <div className="col-md-3">
                                                        <SelectorEscolaridad
                                                            value={escolaridad}
                                                            onChange={setEscolaridad}
                                                            error={errorlist.escolaridad?.[0]}
                                                        />
                                                    </div>



                                                    <div className="col-md-3">
                                                        <SelectorEtnia
                                                            value={etnia}
                                                            onChange={setEtnia}
                                                            error={errorlist.etnia?.[0]}
                                                        />
                                                    </div>

                                                    <div className="col-md-3">
                                                        <SelectorClasificacionPaciente
                                                            value={clasificacion}
                                                            onChange={setClasificacion}
                                                            error={errorlist.clasificacion?.[0]}
                                                        />
                                                    </div>






                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card">
                                        <div className="card-header">
                                            <h4 className="card-title w-100">
                                                <button
                                                    type="button"
                                                    className="btn btn-link d-block w-100 text-left p-0"
                                                    onClick={() => setAcordeonDomicilio(!acordeonDomicilio)}
                                                    aria-expanded={acordeonDomicilio}
                                                    style={{ textDecoration: 'none', color: 'inherit', fontWeight: 'bold' }}
                                                >
                                                    <i className="fas fa-map-marker-alt mr-2 text-info"></i>
                                                    Domicilio del Paciente
                                                </button>
                                            </h4>
                                        </div>
                                        <div className={`collapse ${acordeonDomicilio ? 'show' : ''}`}>
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="direccionPaciente">Dirección <span className="text-danger">*</span></label>
                                                            <input type="text" name="direccion" className={`form-control ${errorlist.direccion ? 'is-invalid' : ''}`} id="direccionPaciente" value={direccion} onChange={(e) => setDireccion(e.target.value)} />
                                                            <div className="invalid-feedback visible">
                                                                {errorlist.direccion?.[0]}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="ciudadResidencia">Ciudad de Residencia <span className="text-danger">*</span></label>
                                                            <SelectorCiudad
                                                                value={ciudadResidencia}
                                                                onChange={setCiudadResidencia}
                                                            />
                                                        </div>
                                                    </div>


                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="paisResidencia">País <span className="text-danger">*</span></label>

                                                            <SelectorPais
                                                                value={paisResidencia}
                                                                onChange={setPaisResidencia}
                                                            />

                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">


                                                    <div className="col-md-2">
                                                        <SelectorZona
                                                            value={zona}
                                                            onChange={setZona}
                                                            error={errorlist.zona?.[0]}
                                                            required={true}
                                                        />
                                                    </div>

                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="telefono">Teléfono</label>
                                                            <input type="text" name="telefono" className={`form-control ${errorlist.telefono ? 'is-invalid' : ''}`} id="telefono" value={telefono} onChange={(e) => setTelefono(e.target.value)} />
                                                            <div className="invalid-feedback visible">
                                                                {errorlist.telefono?.[0]}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="celular">Celular</label>
                                                            <input type="text" name="celular" className={`form-control ${errorlist.celular ? 'is-invalid' : ''}`} id="celular" value={celular} onChange={(e) => setCelular(e.target.value)} />
                                                            <div className="invalid-feedback visible">
                                                                {errorlist.celular?.[0]}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="email">e-mail <span className="text-danger">*</span></label>
                                                            <input type="email" name="email" className={`form-control ${errorlist.email ? 'is-invalid' : ''}`} id="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                                                            <div className="invalid-feedback visible">
                                                                {errorlist.email?.[0]}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card">
                                        <div className="card-header">
                                            <h4 className="card-title w-100">
                                                <button
                                                    type="button"
                                                    className="btn btn-link d-block w-100 text-left p-0"
                                                    onClick={() => setAcordeonDatosAdicionales(!acordeonDatosAdicionales)}
                                                    aria-expanded={acordeonDatosAdicionales}
                                                    style={{ textDecoration: 'none', color: 'inherit', fontWeight: 'bold'}}
                                                >
                                                    <i className="fas fa-layer-group mr-2 text-info"></i>
                                                    Datos Adicionales
                                                </button>
                                            </h4>
                                        </div>
                                        <div className={`collapse ${acordeonDatosAdicionales ? 'show' : ''}`}>
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <SelectorVinculacion
                                                            value={vinculacion}
                                                            onChange={setVinculacion}
                                                            error={errorlist.vinculacion?.[0]}
                                                        />
                                                    </div>
                                                    <div className="col-md-4">
                                                        <SelectorEPS
                                                            value={eps}
                                                            onChange={setEps}
                                                            error={errorlist.eps?.[0]}
                                                            aseguradoras={aseguradoras}
                                                        />
                                                    </div>
                                                    <div className="col-md-4">
                                                        <SelectorClasificacionRiesgo
                                                            value={clasificacionRiesgo}
                                                            onChange={setClasificacionRiesgo}
                                                            error={errorlist.clasificacion_riesgo?.[0]}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <SelectorConvenio
                                                            value={convenio}
                                                            onChange={setConvenio}
                                                            error={errorlist.convenio?.[0]}
                                                            convenios={convenios}
                                                        />
                                                    </div>
                                                    <div className="col-md-4">
                                                        <SelectorMedioPublicitario
                                                            value={medioPublicitario}
                                                            onChange={setMedioPublicitario}
                                                            error={errorlist.medio_publicitario?.[0]}
                                                            mediosPublicitarios={mediosPublicitarios}
                                                        />
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="referidoPor">Referido Por</label>
                                                            <input type="text" name="referido-por" className="form-control" id="referidoPor" value={referido} onChange={(e) => setReferido(e.target.value)} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={`row ${verDescripcionClasificacion}`}>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label htmlFor="descripcion_clasificacion">Descripción Clasificación</label>
                                                            <input type="text" name="descripcion_clasificacion" className="form-control" id="descripcion_clasificacion" value={descripcionClasificacion} onChange={(e) => setDescripcionClasificacion(e.target.value)} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="card">
                                        <div className="card-header bg-light">
                                            <h4 className="card-title w-100 mb-0">
                                                <button
                                                    type="button"
                                                    className="btn btn-link d-block w-100 text-left p-0"
                                                    onClick={() => setAcordeonAcompanante(!acordeonAcompanante)}
                                                    aria-expanded={acordeonAcompanante}
                                                    style={{ textDecoration: 'none', color: 'inherit', fontWeight: 'bold'}}
                                                >
                                                    <i className="fas fa-user-friends mr-2 text-info"></i>
                                                    Acompañante
                                                </button>
                                            </h4>
                                        </div>
                                        <div className={`collapse ${acordeonAcompanante ? 'show' : ''}`}>
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="nombreAcompanante">Nombre</label>
                                                            <input type="text" name="nombre_acompanante" className="form-control" id="nombreAcompanante" value={nombreAcompanante} onChange={(e) => setNombreAcompanante(e.target.value)} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="doc_acompanante">Número de Documento</label>
                                                            <input type="text" name="doc_acompanante" className="form-control" id="doc_acompanante" value={docAcompanante} onChange={(e) => setDocAcompanante(e.target.value)} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="parentesco_acompanante">Parentesco</label>
                                                            <input type="text" name="parentesco_acompanante" className="form-control" id="parentesco_acompanante" value={parentescoAcompanante} onChange={(e) => setParentescoAcompanante(e.target.value)} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label htmlFor="telefonoAcompanante">Teléfono</label>
                                                            <input type="text" name="telefono_acompanante" className="form-control" id="telefonoAcompanante" value={telefonoAcompanante} onChange={(e) => setTelefonoAcompanante(e.target.value)} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label htmlFor="email_acompanante">e-mail</label>
                                                            <input type="text" name="email_acompanante" className="form-control" id="email_acompanante" value={emailAcompanante} onChange={(e) => setEmailAcompanante(e.target.value)} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card">
                                        <div className="card-header bg-light">
                                            <h4 className="card-title w-100 mb-0">
                                                <button
                                                    type="button"
                                                    className="btn btn-link d-block w-100 text-left p-0"
                                                    onClick={() => setAcordeonResponsable(!acordeonResponsable)}
                                                    aria-expanded={acordeonResponsable}
                                                    style={{ textDecoration: 'none', color: 'inherit', fontWeight: 'bold'}}
                                                >
                                                    <i className="fas fa-user-shield mr-2 text-info"></i>
                                                    Responsable
                                                </button>
                                            </h4>
                                        </div>
                                        <div className={`collapse ${acordeonResponsable ? 'show' : ''}`}>
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="nombreResponsable">Nombre</label>
                                                            <input type="text" name="nombre_responsable" className="form-control" id="nombreResponsable" value={nombreResponsable} onChange={(e) => setNombreResponsable(e.target.value)} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="doc_responsable">Número de Documento</label>
                                                            <input type="text" name="doc_responsable" className="form-control" id="doc_responsable" value={docResponsable} onChange={(e) => setDocResponsable(e.target.value)} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="parentesco_responsable">Parentesco</label>
                                                            <input type="text" name="parentesco_responsable" className="form-control" id="parentesco_responsable" value={parentescoResponsable} onChange={(e) => setParentescoResponsable(e.target.value)} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label htmlFor="telefonoResponsable">Teléfono</label>
                                                            <input type="text" name="telefono_responsable" className="form-control" id="telefonoResponsable" value={telefonoResponsable} onChange={(e) => setTelefonoResponsable(e.target.value)} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label htmlFor="email_responsable">e-mail</label>
                                                            <input type="text" name="email_responsable" className="form-control" id="email_responsable" value={emailResponsable} onChange={(e) => setEmailResponsable(e.target.value)} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>



                                    <div className="card">
                                        <div className="card-header">
                                            <h4 className="card-title w-100">
                                                <button
                                                    type="button"
                                                    className="btn btn-link d-block w-100 text-left p-0"
                                                    onClick={() => setAcordeonMenores(!acordeonMenores)}
                                                    aria-expanded={acordeonMenores}
                                                    style={{ textDecoration: 'none', color: 'inherit', fontWeight: 'bold'}}
                                                >
                                                    <i className="fas fa-child mr-2 text-info"></i>
                                                    Información Adicional Solo Para Menores de Edad
                                                </button>
                                            </h4>
                                        </div>
                                        <div className={`collapse ${acordeonMenores ? 'show' : ''}`}>
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="nombreMadre">Nombre de la Madre</label>
                                                            <input type="text" name="nombre-madre" className="form-control" id="nombreMadre" value={nombreMadre} onChange={(e) => setNombreMadre(e.target.value)} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="docMadre">Número de Documento</label>
                                                            <input type="text" name="doc-madre" className="form-control" id="docMadre" value={documentoMadre} onChange={(e) => setDocumentoMadre(e.target.value)} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="telMadre">Teléfono</label>
                                                            <input type="text" name="tel-madre" className="form-control" id="telMadre" value={telefonoMadre} onChange={(e) => setTelefonoMadre(e.target.value)} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="ocupacionMadre">Ocupación</label>
                                                            <input type="text" name="ocupacion-madre" className="form-control" id="ocupacionMadre" value={ocupacionMadre} onChange={(e) => setOcupacionMadre(e.target.value)} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="nombrePadre">Nombre del Padre</label>
                                                            <input type="text" name="nombre-padre" className="form-control" id="nombrePadre" value={nombrePadre} onChange={(e) => setNombrePadre(e.target.value)} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="docPadre">Número de Documento</label>
                                                            <input type="text" name="doc-padre" className="form-control" id="docPadre" value={documentoPadre} onChange={(e) => setDocumentoPadre(e.target.value)} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="telPadre">Teléfono</label>
                                                            <input type="text" name="tel-padre" className="form-control" id="telPadre" value={telefonoPadre} onChange={(e) => setTelefonoPadre(e.target.value)} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="ocupacionPadre">Ocupación</label>
                                                            <input type="text" name="ocupacion-padre" className="form-control" id="ocupacionPadre" value={ocupacionPadre} onChange={(e) => setOcupacionPadre(e.target.value)} />
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row" style={{ marginTop: '20px', marginBottom: '30px' }}>
                                        <div className="col-md-6">
                                            <button type="submit" className="btn btn-primary">
                                                Guardar Cambios&nbsp;
                                                {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null}

                                            </button>&nbsp;

                                            {
                                                //    estadoPaciente=='1' ? (<Link to={'/atender-paciente?id='+pacienteId} className={'btn btn-primary'}>Atender paciente</Link>) : null
                                            }
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </form>
                    </div>
                </section>
            </div>

            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Datos del paciente completados</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <p>{mensajeModal}</p>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>No</Button>
                    <Button variant="primary" onClick={handleAtenderPaciente}>Si</Button>
                </Modal.Footer>
            </Modal>


            <Footer showToast={false} delay={0} />
        </div>

    );
}
export default CrearPaciente2;